export default "__VITE_ASSET__Y_yFcPwj__"